import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Flex,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";

export const MountModal = ({ isOpen, onClose, link }) => {
  const widgetRef = useRef(null);
  const scriptId = "viator-widget-script";

  // useEffect(() => {
  //   // Only attempt to manage the script if the drawer is opened or closed
  //   if (isOpen) {
  //     if (!document.getElementById(scriptId)) {
  //       const script = document.createElement("script");
  //       script.id = scriptId;
  //       script.src = "https://www.viator.com/orion/partner/widget.js";
  //       script.async = true;
  //       document.body.appendChild(script);
  //     }
  //   } else {
  //     // Remove script when the drawer is closed to clean up
  //     const existingScript = document.getElementById(scriptId);
  //     if (existingScript) {
  //       document.body.removeChild(existingScript);
  //     }
  //     // Additionally, clear the inner HTML of the div to remove any residual data from the widget
  //     if (widgetRef.current) {
  //       widgetRef.current.innerHTML = "";
  //     }
  //   }
  // }, [isOpen]);

  // useEffect(() => {
  //   if (isOpen) {
  //     console.log(link);
  //   }
  // }, [isOpen]);

  return (
    <Drawer placement={"bottom"} onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent maxH={"90vh"} zIndex={"100"}>
        <Flex
          mx={3}
          my={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text mr={4} fontSize={"18px"} fontWeight={800}>
            Local Experiences
          </Text>

          <DrawerCloseButton pos={"relative"} top={0} right={0} />
        </Flex>
        <DrawerBody px={0} pt={0} pb={12}>
          <iframe src={link} width="100%" height="800px" frameBorder="0" />
          {/* 
          <div
            ref={widgetRef}
            data-vi-partner-id="U00558081"
            data-vi-widget-ref="W-bf11f601-916c-4563-8c2b-0b9fabb10303"
          ></div> */}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
